package ai.flowstorm.common.ui

enum class Icon(val def: String) {

    Help("fa-icon fas fa-question-circle"),
    Doc("fa-icon fas fa-lightbulb"),
    Run("fa-icon fas fa-play"),
    Bug("fa-icon fas fa-bug"),
    Debug("fa-icon fas fa-debug"),
    Stop("fa-icon fas fa-stop"),
    Pause("fa-icon fas fa-pause"),
    New("fa-icon fas fa-file-medical"),
    Import("fa-icon fas fa-file-import"),
    Export("fa-icon fas fa-file-export"),
    Open("fa-icon fas fa-folder-open"),
    Save("fa-icon fas fa-save"),
    Undo("fa-icon fas fa-undo-alt"),
    Redo("fa-icon fas fa-redo-alt"),
    Copy("fa-icon fas fa-copy"),
    Paste("fa-icon fas fa-paste"),
    Delete("fa-icon fas fa-trash-alt"),
    History("fa-icon fas fa-history"),
    ZoomIn("fa-icon fas fa-search-plus"),
    ZoomOut("fa-icon fas fa-search-minus"),
    Fit("fa-icon fas fa-expand-arrows-alt"),
    Build("fa-icon fas fa-hammer"),
    BulkBuilder("fa-icon fas fa-hammer"),
    SimulationDesigner("fa-icon fas fa-route"),
    Expand("fa-icon fas fa-expand"),
    FileAsset("fa-icon fas fa-photo-video"),
    Graph("fa-icon fas fa-sitemap"),
    DialogueMixin("fa-icon fas fa-shapes"),
    Text("fa-icon fas fa-text"),
    Strikethrough("fa-icon fas fa-strikethrough"),
    Xml("fas fa-code"),
    Xsl("fad fa-code"),
    Magic("fad fa-magic"),
    Function("fa-icon fas fa-function"),
    Properties("fa-icon fas fa-cog"),
    Signal("fa-icon fas fa-wave-square"),
    Turn("fa-icon fas fa-comment-alt"),
    Session("fa-icon fas fa-comments-alt"),
    Sessions("fa-icon fad fa-comments-alt"),
    User("fa-icon fas fa-user"),
    Community("fa-icon fas fa-users"),
    Description("fa-icon fas fa-info"),
    ReportPanel("fa-icon fas fa-chart-bar"),
    RootReportPanel("fa-icon fas fa-chart-bar"),
    Device("fa-icon fas fa-computer-speaker"),
    UserGroup("fa-icon fas fa-user-friends"),
    UserAssignment("fa-icon fas fa-user-cog"),
    Invitation("fa-icon fas fa-user-plus"),
    Application("fa-icon fas fa-store"),
    Initiation("fa-icon fas fa-phone-volume"),
    DialogueEvent("fa-icon fas fa-exclamation-triangle"),
    DialogueSource("fa-icon fas fa-file-code"),
    Source("fa-icon fas fa-brackets-curly"),
    Right("fa-icon fas fa-caret-right"),
    Down("fa-icon fas fa-caret-down"),
    Voice("fa-icon fas fa-waveform-path"),
    SpeechRecognizer("fa-icon fas fa-microphone-alt"),
    Tools("fa-icon fas fa-tools"),
    Footer("fa-icon fas fa-shoe-prints"),
    UserLock("fa-icon fas fa-user-lock"),
    Lock("fa-icon fas fa-lock-alt"),
    List("fa-icon fas fa-bars"),
    Node("fa-icon fas fa-square"),
    Focus("fa-icon fas fa-location"),
    Search("fa-icon fas fa-search"),
    Image("fa-icon fas fa-image"),
    Images("fa-icon fas fa-images"),
    Music("fa-icon fas fa-music"/*"far fa-speakers"*/),
    Waypoint("fa-icon fas fa-location-arrow"),
    Location("fa-icon fas fa-map-marker-alt"),
    Simulation("fa-icon fas fa-running"),
    LeftPanel("fa-icon far fa-window-maximize fa-rotate-270"),
    RightPanel("fa-icon far fa-window-maximize fa-rotate-90"),
    Bottom("fa-icon fas fa-arrow-to-bottom"),
    Reload("fa-icon fas fa-sync-alt"),
    Microphone("fa-icon fas fa-microphone"),
    VolumeUp("fa-icon fas fa-volume-up"),
    VolumeDown("fa-icon fas fa-volume-down"),
    Clear("fa-icon fas fa-trash-alt"),
    Matrix("fa-icon fas fa-border-all"),
    Workflow("fa-icon fas fa-repeat-alt"),
    Advanced("fas fa-flask"),
    Edit("fa-icon fas fa-edit"),
    Plus("fa-icon fas fa-plus-square"),
    Bot("fa-icon fas fa-robot"),
    Home("fa-icon fas fa-home"),
    SignUp("fa-icon fad fa-user-plus"),
    LogIn("fa-icon fad fa-sign-in"),
    LogOut("fa-icon fas fa-sign-out"),
    Account("fa-icon fas fa-dollar-sign"),
    Space("fa-icon fas fa-warehouse"),
    EntityDataset("fa-icon fas fa-database"),
    DialogueSnippetDesigner("fa-icon fas fa-sitemap"),
    DialogueSourceDesigner("fa-icon fas fa-sitemap"),
    Moon("fa-icon fas fa-moon"),
    Sun("fa-icon fas fa-sun"),
    Mobile("fa-icon fas fa-mobile"),
    MobileAlt("fa-icon fas fa-mobile-alt"),
    Tablet("fa-icon fas fa-tablet"),
    TabletAlt("fa-icon fas fa-tablet-alt"),
    Desktop("fa-icon fas fa-desktop"),
    Payload("fa-icon far fa-brackets-curly"),
    External("fa-icon fas fa-external-link-alt")
}

fun iconFor(obj: Any): Icon? = try {
    Icon.valueOf(obj::class.simpleName!!.removeSuffix("Table").removeSuffix("Page"))
} catch (e: Throwable) {
    null
}
